import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Typography
} from '@material-ui/core';
import React, { FC, memo, useCallback } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { MuiInput } from '../../shared/form-element';

const InputWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  companyName: string | undefined;
  companyNameErrors: string[] | undefined;
  companyNameOnInput: (v: string) => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const EditCompanyDialogView: FC<Props> = memo(
  ({
    open,
    onClose,
    companyName = '',
    companyNameErrors = [],
    companyNameOnInput,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => {
    const onCloseByEscape = useCallback(() => {
      onClose('');
    }, [onClose]);

    const cancelOnClick = useCallback(() => {
      onClose('cancel');
    }, [onClose]);

    const okOnClick = useCallback(() => {
      onClose('ok');
    }, [onClose]);

    return (
      <Dialog open={open} onClose={onCloseByEscape}>
        <DialogTitle>{viewTexts.dialogs.editCompany.title}</DialogTitle>
        <DialogContent>
          <Typography>{viewTexts.dialogs.editCompany.description1}</Typography>
          <Typography>{viewTexts.dialogs.editCompany.description2}</Typography>
          <InputWrapper>
            <MuiInput
              label={viewTexts.dialogs.editCompany.label}
              required={true}
              value={companyName}
              onInput={companyNameOnInput}
              helperText={companyNameErrors.join(' ')}
              error={companyNameErrors.length > 0}
            />
          </InputWrapper>
          {nonFieldErrors.map((er, i) => (
            <FormHelperText key={i} error={true}>
              {er}
            </FormHelperText>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelOnClick} color='default'>
            {viewTexts.dialogs.editCompany.cancel}
          </Button>
          <Button
            disabled={!submitButtonEnabled}
            onClick={okOnClick}
            color='primary'
            autoFocus={true}
          >
            {viewTexts.dialogs.editCompany.ok}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

EditCompanyDialogView.displayName = 'EditCompanyDialogView';
